// Generated by purs version 0.15.15
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Restaumatic_Address from "../Restaumatic.Address/index.js";
var toStoredDeliveryAddress = function (x) {
    return {
        street: new Data_Maybe.Just(x.street),
        streetNumber: new Data_Maybe.Just(x.streetNumber),
        city: new Data_Maybe.Just(x.city),
        postCode: new Data_Maybe.Just(x.postCode)
    };
};
var fromStoredDeliveryAddress = function (x) {
    var fromNullable = Data_Maybe.fromMaybe("");
    return {
        street: fromNullable(x.street),
        streetNumber: fromNullable(x.streetNumber),
        city: fromNullable(x.city),
        postCode: fromNullable(x.postCode),
        extra: Restaumatic_Address.emptyAddressExtra
    };
};
export {
    fromStoredDeliveryAddress,
    toStoredDeliveryAddress
};
